import { render, staticRenderFns } from "./support-contact-info-card.vue?vue&type=template&id=6b115c8a&scoped=true&"
import script from "./support-contact-info-card.vue?vue&type=script&lang=js&"
export * from "./support-contact-info-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b115c8a",
  null
  
)

export default component.exports